import { Injectable } from "@angular/core";
import { EnvironmentconfigService } from "../service/environmentconfig.service";
import { AuthService } from "./auth.service";
import { WebApiService } from "../service/webapi.service";
import { URLConst } from "../const/url.const";
import { TResult } from "../models/common-models";
import { JsFndaUser } from "src/app/layout/models/layout-model";
import { NzMessageService } from "ng-zorro-antd/message";

@Injectable({
    providedIn: 'root'
})

export class LayoutService {
    constructor(
        private EnvironmentconfigService: EnvironmentconfigService,
        private auth: AuthService,
        private WebApiService: WebApiService,
        private messageServ: NzMessageService
    ) {
    }

    async setUserInfo() {
        const switchedToken = this.auth.getSwitchedToken();
        if (switchedToken) {
            const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.GetUserInfo.url}${localStorage.getItem('wmsmlang')}`; //call new mvm-api
            const res = await this.WebApiService.doGet(url).toPromise() as TResult<JsFndaUser>;
            if (res.rc === 0 && res.data) {
                this.auth.setSwitched(switchedToken, res.data);
            } else {
                this.auth.setSwitched('', undefined);
                this.messageServ.error(res.msg, { nzDuration: 5000 });
            }
        } else {
            const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.GetUserInfo.url}${localStorage.getItem('wmsmlang')}`; //call new mvm-api
            const res = await this.WebApiService.doGet(url).toPromise() as TResult<JsFndaUser>;
            if (res.rc === 0 && res.data) {
                this.auth.setLoginUser(res.data);
            }
            else if (res.rc === 1302) {
                //1302:代表賬號存在，但未啟用；
                // 因為與PCP同步啟用狀態需要1天時間 耽誤廠商登入，所以當廠商已經完成註冊登入進來的時候，直接後台啟用賬號
                const enableAccUrl = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.ForceEnableVendorCustomerAccount.url}${localStorage.getItem('wmsmlang')}`;
                const enableRes = await this.WebApiService.doGet(enableAccUrl).toPromise() as TResult<boolean>;
                if (enableRes.rc === 0 && enableRes.data) {
                    //啟用成功,導到callback重新獲取用戶信息
                    window.location.href = 'login/callback';
                } else {
                    this.auth.setLoginUser(undefined);
                    this.messageServ.error(enableRes.msg, { nzDuration: 5000 });
                }
            }
            else {
                this.auth.setLoginUser(undefined);
                this.messageServ.error(res.msg, { nzDuration: 5000 });
            }
        }

        const userInfo = this.auth.getCurrentUserInfo();
        if (userInfo) {
            const timezoneoffset = new Date().getTimezoneOffset();
            userInfo.timezone = -timezoneoffset / 60;
            if (this.auth.getSwitchedToken()) {
                this.auth.setSwitched(this.auth.getSwitchedToken()!, userInfo);
            }
            else {
                this.auth.setLoginUser(userInfo);
            }
        }
    }
    getUserTypeDisplay(userType: string) {
        switch (userType) {
            case 'User':
                return 'Employee';
            case 'Vendor':
                return 'Vendor';
            case 'GuestVendor':
                return 'Guest Vendor';
            case 'Customer':
                return 'Customer';
            case 'GuestCustomer':
                return 'Guest Customer';
            default:
                return userType;
        }
    }
}